<template>
  <aside
    class="preview-navigation-rail"
    :style="railStyle"
  >
    <!-- 店舗トップ（ロゴ/アイコン） -->
    <button
      class="nav-item nav-item--top"
      :style="itemStyle(false)"
    >
      <img
        v-if="logoUrl"
        :src="logoUrl"
        alt="Logo"
        class="top-logo"
      >
      <v-icon
        v-else
        small
        :color="theme.textColor"
      >
        {{ icons.mdiHome }}
      </v-icon>
      <span
        class="nav-label"
        :style="labelStyle"
      >TOP</span>
    </button>

    <!-- カテゴリ一覧 -->
    <nav class="nav-categories">
      <button
        v-for="category in categories"
        :key="category.vendibleTagId"
        class="nav-item"
        :class="{ 'nav-item--active': selectedCategoryId === category.vendibleTagId }"
        :style="itemStyle(selectedCategoryId === category.vendibleTagId)"
        @click="$emit('select-category', category.vendibleTagId)"
      >
        <v-icon
          small
          :color="selectedCategoryId === category.vendibleTagId ? theme.primaryColor : theme.textColor"
          :style="{ opacity: selectedCategoryId === category.vendibleTagId ? 1 : 0.7 }"
        >
          {{ getIconSvg(category.icon) }}
        </v-icon>
        <span
          class="nav-label"
          :style="labelStyle"
        >{{ category.vendibleTagName }}</span>
      </button>
    </nav>
  </aside>
</template>

<script>
import { computed } from '@vue/composition-api'
import {
  mdiTag,
  mdiHome,
  mdiMenu,
  mdiGlassMugVariant,
  mdiGlassWine,
  mdiGlassCocktail,
  mdiCup,
  mdiBottleWine,
  mdiBottleWineOutline,
  mdiSilverwareForkKnife,
  mdiFood,
  mdiCakeVariant,
  mdiShimmer,
  mdiStar,
  mdiHeart,
  mdiGift,
  mdiFlower,
  mdiCamera,
  mdiMusic,
  mdiCog,
} from '@mdi/js'

// アイコン値からSVGパスへのマッピング
const ICON_MAP = {
  default: mdiTag,
  home: mdiHome,
  menu: mdiMenu,
  beer: mdiGlassMugVariant,
  wine: mdiGlassWine,
  cocktail: mdiGlassCocktail,
  drink: mdiCup,
  bottle: mdiBottleWine,
  champagne: mdiBottleWineOutline,
  utensils: mdiSilverwareForkKnife,
  food: mdiFood,
  cake: mdiCakeVariant,
  sparkles: mdiShimmer,
  star: mdiStar,
  heart: mdiHeart,
  gift: mdiGift,
  flower: mdiFlower,
  camera: mdiCamera,
  music: mdiMusic,
  settings: mdiCog,
}

export default {
  name: 'PreviewNavigationRail',

  props: {
    theme: {
      type: Object,
      required: true,
    },
    logoUrl: {
      type: String,
      default: null,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    iconOptions: {
      type: Array,
      default: () => [],
    },
    selectedCategoryId: {
      type: [String, Number],
      default: null,
    },
  },

  setup() {
    // アイコン値からSVGパスを取得
    const getIconSvg = iconValue => ICON_MAP[iconValue] || mdiTag

    // レールのスタイル
    const railStyle = computed(() => ({
      backgroundColor: 'var(--preview-card)',
    }))

    // アイテムのスタイル
    const itemStyle = isActive => ({
      borderLeftColor: isActive ? 'var(--preview-primary)' : 'transparent',
      backgroundColor: isActive ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
    })

    // ラベルのスタイル
    const labelStyle = computed(() => ({
      color: 'var(--preview-text)',
    }))

    return {
      getIconSvg,
      railStyle,
      itemStyle,
      labelStyle,

      icons: {
        mdiHome,
      },
    }
  },
}
</script>

<style scoped>
.preview-navigation-rail {
  width: 60px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.nav-categories {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 4px;
  border: none;
  background: transparent;
  border-left: 2px solid transparent;
  cursor: pointer;
  gap: 2px;
  transition: all 0.2s ease;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.nav-item--top {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.top-logo {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  object-fit: contain;
}

.nav-label {
  font-size: 8px;
  line-height: 1.2;
  text-align: center;
  opacity: 0.8;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
